import React from 'react'
import Bullet from '../components/Bullet'

const PrivacyPolicy = () => {


    return (
        <div className='flex flex-col gap-8 p-20'>
            <div>
                <h1 className='text-lg font-bold'>Last updated:2025-04-01</h1>
                <p>
                    Smart Dairy App ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application ("App"). Please read this privacy policy carefully. If you do not agree with the terms of this policy, please do not access the app.
                </p>
            </div>

            <div>
                <h2 className='font-bold'>1. Information We Collect</h2>
                <p>We may collect information about you in a variety of ways. The information we may collect via the App includes</p>
                <div className='ml-4 mt-4 flex flex-col gap-2'>
                    <div>
                        <h3 className='font-bold'>a. Personal Data: </h3>
                        <p>Personally identifiable information (such as your name, email address, and phone number) that you voluntarily give to us when you register within the App, subscribe to a service, or communicate with us.</p>
                    </div>
                    <div>
                        <h3 className='font-bold'>b. User Data: </h3>
                        <p>Information automatically collected when you access the App, includes your only User's Mobile Number</p>
                    </div>
                    <div>
                        <h3 className='font-bold'>c. Device Data: </h3>
                        <p>Information about your device, such as your mobile device ID.</p>
                    </div>
                    <div>
                        <h3 className='font-bold'>d. Location Data: </h3>
                        <p>We do not collect data related to your location if you enable location services for the App.</p>
                    </div>
                </div>
            </div>

            <div>
                <h2 className='font-bold'>2. How We Use Your Information</h2>
                <p>We use the information we collect to</p>

                <div className='mt-4 ml-4 gap-2 flex flex-col'>
                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Provide and maintain our App</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Improve, personalize, and expand our App.</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Analyze how users interact with the App.</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Develop new products, services, features, and functionality</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Communicate with you for customer service, updates, and promotional purposes.</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Protect against illegal activities and security threats.</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Comply with legal requirements..</p>
                    </div>

                </div>
            </div>


            <div>
                <h2 className='font-bold'>3. Sharing Your Information</h2>
                <p>We do not share your personal information with third parties, except in the following circumstances</p>

                <div className='mt-4 ml-4 gap-2 flex flex-col'>
                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>With service providers who perform functions on our behalf (e.g., data storage, analytics).</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>To comply with legal obligations or protect the rights, property, or safety of Smart Dairy App, our users, or others.</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>In connection with a merger, sale, or acquisition of our company.</p>
                    </div>
                </div>
            </div>


            <div>
                <h2 className='font-bold'>4. Data Security</h2>
                <p>We use a variety of security measures to ensure the protection of your personal information. However, please note that no method of electronic transmission or storage is completely secure.</p>
            </div>

            <div>
                <h2 className='font-bold'>5. Third-Party Links</h2>
                <p>Our App may contain links to third-party websites or services that are not operated by us. We are not responsible for the privacy practices of these third parties, and we encourage you to review their privacy policies.</p>
            </div>

            <div>
                <h2 className='font-bold'>6. Your Data Rights</h2>
                <p>Depending on your location, you may have the following rights</p>

                <div className=' ml-4 mt-4 gap-2 flex flex-col'>
                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Access, correct, or delete your personal information.</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Restrict or object to our processing of your data.</p>
                    </div>

                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Data portability.</p>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <Bullet />
                        <p>Withdraw consent at any time (if the processing is based on consent).</p>
                    </div>
                </div>

                <p className='mt-4'>If you wish to exercise these rights, please contact us at support@smartdairy.co.in.</p>
            </div>

            <div>
                <h2 className='font-bold'>7. Children’s Privacy</h2>
                <p>Our App is not intended for children under 13 years of age, and we do not knowingly collect personal information from children under 13. If we discover that we have collected such information, we will take immediate steps to delete it.</p>
            </div>

            <div>
                <h2 className='font-bold'>8. Changes to This Privacy Policy</h2>
                <p>We may update this privacy policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this policy periodically to stay informed.</p>
            </div>

            <div>
                <h2 className='font-bold'>9. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                <p className='font-semibold'>Email: support@smartdairy.co.in</p>
            </div>
        </div>
    )
}

export default PrivacyPolicy
